export default __webpack_public_path__ + "static/media/dropdown-arrow.240176b4.svg";